import { Injectable, NgZone, inject } from '@angular/core';
import { Observable, finalize, shareReplay, tap } from 'rxjs';
import { LoaderService } from '@shared/services/loader.service';
import { SessionLoadResult } from '../models/session.model';
import { AuthStateService } from './auth-state.service';
import { SessionService } from './session.service';

@Injectable({ providedIn: 'root' })
export class SessionControllerService {
  //* Services
  private readonly _authState = inject(AuthStateService);
  private readonly _sessionService = inject(SessionService);
  private readonly _loader = inject(LoaderService);
  private readonly _ngZone = inject(NgZone);

  //* Variables
  private _request$: Observable<SessionLoadResult> | null = null;
  private _isLoaderVisible = false;

  //* Public Methods
  public loadSession(): Observable<SessionLoadResult> {
    if (this._request$) return this._request$;

    this._showLoader();
    this._request$ = this._sessionService.getSession().pipe(
      tap((result) => this._ngZone.run(() => this._authState.setSession(result.session))),
      finalize(() => this._ngZone.run(() => this._hideLoader())),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    return this._request$;
  }

  public refreshSession(): Observable<SessionLoadResult> {
    this._request$ = null;
    return this.loadSession();
  }

  public clear(): void {
    this._request$ = null;
    this._hideLoader();
    this._authState.clearSession();
  }

  public signOut(): void {
    this.clear();
    this._authState.signOut();
  }

  //* Private Methods
  private _showLoader(): void {
    if (this._isLoaderVisible) return;

    this._isLoaderVisible = true;
    this._loader.show('Cargando sesión...');
  }

  private _hideLoader(): void {
    if (!this._isLoaderVisible) return;

    this._isLoaderVisible = false;
    this._loader.hide();
  }
}
